import Vue from 'vue';
import Router from 'vue-router';
import Top from '@/components/pages/Top';
import Recruit from '@/components/pages/Recruit'
import Contact from '@/components/pages/Contact'
import Privacy_policy from '@/components/pages/Privacy_policy'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacy_policy',
      name: 'Privacy_policy',
      component: Privacy_policy
    },
    {
      path: '*',
      redirect: {
        name: "Top"
      }
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // ハッシュがある時にはその地点へとスクロールする
    const selector = location.hash
    return selector ? { selector } : { x: 0, y: 0 }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js